import styled from 'styled-components'
import { Image as BoltImage, Modal as BoltModal } from '@sainsburys-tech/bolt'

const SizeGuide = styled.div`
  display: inline-flex;
  margin-left: auto;
  flex-shrink: 0;

  > a {
    top: -6px;
    position: relative;
  }

  svg {
    position: relative;
    top: 6px;

    .ac-icon {
      position: relative;
      top: 2px;
    }
  }
`

const Modal = styled(BoltModal)`
  && {
    [role='dialog'] {
      z-index: ${props => props.theme.modifier.layer['20']};
      max-width: ${props => {
        return props.isBranded ? '900px' : '1340px'
      }};

      max-height: none;
    }
  }
`
const Image = styled(BoltImage)`
  width: 100%;
`

export { SizeGuide, Modal, Image }
